import React from "react";

const SelectStyle = {
  backgroundColor: "#8971E1",
  borderRadius: "5px",
  minWidth: "100%",
  height: "60px",
  color: "white",
};

class Answer extends React.Component {
  onChange = (e) => {
    window.open(
      `${e.target.value}`,
      "_blank" // <- This is what makes it open in a new window.
    );
  };
  render() {
    return (
      <select onChange={this.onChange} style={SelectStyle}>
        <option>Selectati</option>
        <option value="https://drive.google.com/file/d/1L9P2EFIVc7tihyJeW8Y8DiOhI4xGEVF7/view?usp=sharing">
          Economie Si Drept
        </option>
        <option value="https://drive.google.com/file/d/1w5mScNnRIAZum1cvZsLngI_pbHU16xDB/view?usp=sharing">
          Farmacie
        </option>
        <option value="https://drive.google.com/file/d/1GXeGJskKlh8MOgDRZkSVtAkFpCqg1LAY/view?usp=sharing">
          Inginerie
        </option>
        <option value="https://drive.google.com/file/d/1qfLrwYA8AUg3Slt0fqGPJUMPuhJKP8Pl/view?usp=sharing">
          Medicina
        </option>
        <option value="https://drive.google.com/file/d/1e7WBx-7lwrKrTkhzrtpC79-L4f281ADc/view?usp=sharing">
          Medicina Dentara
        </option>
        <option value="https://drive.google.com/file/d/1Pr4A3UphPSHKp0Sz3XuhA3fIwounmE0R/view?usp=sharing">
          Medicina engleza
        </option>
        <option value="https://drive.google.com/file/d/1vv8tl1VAhW0h2hYPsT5ArfX7mB3a7XB8/view?usp=sharing">
          Oficiul Pentru Admitere
        </option>
        <option value="https://drive.google.com/file/d/1l9CsDxd_KFxCId810ilsOz5NfzkOGqBo/view?usp=sharing">
          Stiinte Si Litere
        </option>
      </select>
    );
  }
}

export default Answer;
